
/* ============================== src/components/Clickable.jsx ============================== */
/**
 * Кликабельная поверхность: строка, карточка, чип.
 *
 * as="button" (по умолчанию) - фокус, Enter/Space, role отдаются
 * браузером. as="div" - когда внутри уже есть <button> (FloatingMenu,
 * бейдж непрочитанного): HTML запрещает вложенные <button>, поэтому
 * родитель рендерится div'ом с role="button" и обработкой Enter/Space.
 *
 * Стилей не навязывает: вызывающий добавляет className, сброс
 * дефолтного вида button - в CSS-утилите .clickable-reset.
 */
export function Clickable({
  onClick,
  as = "button",
  className,
  children,
  disabled = false,
  ...rest
}) {
  if (as === "button") {
    return (
      <button
        type="button"
        className={className}
        onClick={onClick}
        disabled={disabled}
        {...rest}
      >
        {children}
      </button>
    );
  }

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled || undefined}
      className={className}
      onClick={disabled ? undefined : onClick}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {children}
    </div>
  );
}
